// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const LeftNavContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-leftnav" */ "./LeftNavContainer")).then((bundle)=>{
        return {
            default: bundle.LeftNavContainer
        };
    });
export const LazyLeftNavContainer = /*#__PURE__*/ lazy(LeftNavContainerLazyLoader);
